const localeToCountryPhoneAbbr = {
  en: 'us',
  cs: 'cz',
  uk: 'ua',
} as const;

export default localeToCountryPhoneAbbr;
